import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

type SideBarMode = "view" | "edit" | "invisible";
type MainContentMode = "view" | "edit";

export type CommunityPageState = {
    sideBarMode: SideBarMode;

    setSideBarMode: (mode: SideBarMode) => void;

    mainContentMode: MainContentMode;

    setMainContentMode: (mode: MainContentMode) => void;

    clear: () => void;
};

export const communityPageStateStore = (
    set: (state: Partial<CommunityPageState>) => void,
    get: () => CommunityPageState,
): CommunityPageState => ({
    sideBarMode: "view",
    setSideBarMode: (_sideBarMode: SideBarMode) => {
        const currentState = get();

        if (currentState.sideBarMode !== _sideBarMode) {
            set({ ...currentState, sideBarMode: _sideBarMode });
        }
    },
    mainContentMode: "view",
    setMainContentMode: (_mainContentMode: MainContentMode) => {
        const currentState = get();

        if (currentState.mainContentMode !== _mainContentMode) {
            set({ ...currentState, mainContentMode: _mainContentMode });
        }
    },

    clear: () => {
        set({
            sideBarMode: "view",
            mainContentMode: "view",
        });
    },
});
